import { HttpInterceptorFn } from '@angular/common/http';

/** Register last in provideHttpClient: earlier interceptors read withCredentials as "attach a token". */
export const cookielessBearerHostInterceptor: HttpInterceptorFn = (req, next) =>
  next(req.withCredentials ? req.clone({ withCredentials: false }) : req);
